/**
 * Workstation del PHU donde el producto tiene un hueco.
 * Devuelve null si el producto no está asignado a ningún PHU.
 */
export const workstationIdFromPhus = (phus, productId) => {
    if (productId == null || productId === '') {
        return null
    }
    const productKey = String(productId)
    const phu = (phus || []).find((item) => (item.slots || []).some((slot) => (
        slot.product_id != null && slot.product_id !== '' && String(slot.product_id) === productKey
    )))

    return phu ? phu.workstation_id : null
}
